<template>
  <b-form-group
    label="Yıl"
    label-for="year"
  >
    <validation-provider
      #default="{ errors }"
      name="Bağlantı Adresi"
      rules="required"
    >
      <b-form-input
        id="year"
        v-model="dataItem.year"
        placeholder="Yıl"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'Url',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['history/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
